/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ProcessingInputs */

const en_processing = /** @type {(inputs: ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing...`)
};

const fr_processing = /** @type {(inputs: ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traitement...`)
};

const de_processing = /** @type {(inputs: ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verarbeitung...`)
};

const it_processing = /** @type {(inputs: ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elaborazione in corso...`)
};

const ru_processing = /** @type {(inputs: ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обработка...`)
};

const es_processing = /** @type {(inputs: ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tratamiento...`)
};

const zh_cn2_processing = /** @type {(inputs: ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加工...`)
};

const ja_processing = /** @type {(inputs: ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`処理...`)
};

const hi_processing = /** @type {(inputs: ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रक्रिया जारी है...`)
};

const pt_pt2_processing = /** @type {(inputs: ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processamento...`)
};

/**
* | output |
* | --- |
* | "Processing..." |
*
* @param {ProcessingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const processing = /** @type {((inputs?: ProcessingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ProcessingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_processing(inputs)
	if (locale === "de") return de_processing(inputs)
	if (locale === "it") return it_processing(inputs)
	if (locale === "ru") return ru_processing(inputs)
	if (locale === "es") return es_processing(inputs)
	if (locale === "zh-CN") return zh_cn2_processing(inputs)
	if (locale === "ja") return ja_processing(inputs)
	if (locale === "hi") return hi_processing(inputs)
	if (locale === "pt-PT") return pt_pt2_processing(inputs)
	return en_processing(inputs)
});